import React from 'react';
import { Box } from '@mui/material';
import { NotesOutlined } from '@mui/icons-material';
import { SectionHeader, SectionPaper } from '../../../../common/components/styled-ui-elements';
import { NotesEdit } from '../fields';

/**
 * NotesSection - Asset notes field
 * Contains additional notes text area
 */
export const NotesSection: React.FC = () => {
  return (
    <Box>
      <SectionHeader
        icon={<NotesOutlined sx={{ mr: 1, color: '#3b82f6', fontSize: 18 }} />}
        title="Notes"
      />
      <SectionPaper>
        <NotesEdit />
      </SectionPaper>
    </Box>
  );
};

export default NotesSection;
